<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">

        <div class="mt-3">
          <label class="txt-right required">Trang trại</label>
          <Dropdown 
            :disabled="mode=='edit'"
            v-model="farm"
            :options="listFarm"
            optionLabel="name"
            placeholder="Tên trang trại"/>
          <input class="input_tmp_validator" id="farm" />
        </div>

        <div class="mt-3">
          <label class="txt-right">Unit</label>
          <MultiSelect v-model="unit" :disabled="mode=='edit'" :options="unitOptions" :filter="true" :showToggleAll="false" optionLabel="name" placeholder="Chọn">
            <template #value="">
              Chọn
            </template>
          </MultiSelect>

          <div class="mt-2" v-show="unit.length > 0">
            <label v-for="(item, index) in unit" :key="`unit-span-${index}`" class="cus-tags">
              <span class="cs-tag">
                {{item.name}}
              </span>
              <i v-show="mode=='add'" class="fas fa-times cs-icon" v-on:click="removeSpan(index, 'unit')"></i>
            </label>
          </div>
        </div>

        <div class="mt-3">
          <label class="txt-right required">Phân công</label>
          <MultiSelect v-model="user" :disabled="mode=='edit'" :options="userOptions" :filter="true" :showToggleAll="false" optionLabel="fullname" placeholder="Chọn">
            <template #value="">
              Chọn
            </template>
          </MultiSelect>

          <div class="mt-2" v-show="user.length > 0">
            <label v-for="(item, index) in user" :key="`user-span-${index}`" class="cus-tags">
              <span class="cs-tag">
                {{item.fullname}}
              </span>
              <i v-show="mode=='add'" class="fas fa-times cs-icon" v-on:click="removeSpan(index, 'user')"></i>
            </label>
          </div>
          <input class="input_tmp_validator" id="user" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Loại công việc</label>
          <Dropdown 
            :disabled="mode=='edit'"
            v-model="type_work"
            :options="listTypeWork"
            optionLabel="name"
            placeholder="Loại công việc"/>
          <input class="input_tmp_validator" id="type_work" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Tên công việc</label>
          <InputText
            v-model="name"
            id="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            :disabled="mode=='edit'"
          />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Trạng thái công việc</label>
          <Dropdown 
            :disabled="mode=='add'"
            v-model="status"
            :options="listStatus"
            optionLabel="name"
            placeholder="Trạng thái công việc"/>
          <input class="input_tmp_validator" id="status" />
        </div>

        <div class="mt-3">
          <label class="txt-right required">Ngày hoàn thành</label>
          <Calendar 
            :disabled="mode == 'edit'" 
            v-model="deadline_time" 
            dateFormat="dd/mm/yy" 
            placeholder="DD/MM/YYYY" 
            :showButtonBar="true" 
            :showIcon="true"/>
          <input class="input_tmp_validator" id="deadline_time" />
        </div>

        <div class="mt-3">
          <label class="txt-right">Ghi chú</label>
          <Textarea
            v-model="content"
            :autoResize="true"
            rows="3"
            maxlength="2000"
            class="input-text-box"
            placeholder="Nhập (tối đa 2,000 ký tự)"
            :disabled="mode=='edit'"
          />
        </div>
        
      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from "@/core/DataServices";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      status: null,
      listStatus: [],
      farm: null,
      listFarm: [],
      unit: [],
      unitOptions: [],
      user: [],
      userOptions: [],
      type_work: null,
      listTypeWork: [],
      name: "",
      deadline_time: null,
      content: "",
      spans: [],
    };
  },
  async mounted() {
    // console.log("this.model", this.model);
    await this.getListStatus();
    await this.getListFarm();
    await this.getListTypeWork();
    if (this.mode === "add") {
      this.status = this.listStatus.find((status) => status.id == 1);
    }
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      try {
        if (this.model.status) {
          this.status = this.model.status;
        }
        if (this.model.farm_has_works) {
          this.farm = this.listFarm.find(
            (farm) => farm.id === this.model.farm_has_works.farm.id
          );
        }
        await this.getListUnit();
        await this.getListUser();
        this.unit = this.model.unit_has_works.map((unit) => {
          return this.unitOptions.find((item) => item.id === unit.unit.id);
        });
        this.user = this.model.work_assign_users.map((user) => {
          return this.userOptions.find((item) => item.id === user.user.id);
        });
        this.type_work = this.model.type_work;
        this.name = this.model.name;
        this.deadline_time = new Date(this.model.deadline_time);
        this.content = this.model.content;
        
        this.$commonFuction.is_loading(false);
      } catch(err) {
        console.log("Errrr", err);
        this.$commonFuction.is_loading(false);
      }
    }
  },
  watch: {
    async "farm"() {
      if (this.farm) {
        this.unit = [];
        this.user = [];
        await this.getListUnit();
        await this.getListUser();
      }
    },
    "user": {
      handler() {
        this.updateSpans();
      },
      deep: true
    },
    "unit": {
      handler() {
        this.updateSpans();
      },
      deep: true
    }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },

    async getListStatus() {
      var gqLQueryList = DataServices.getList("status", { "fields": "id, name" });
      var where = {
        deleted: { _eq: false }
      };
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" }
        }
      });
      var listData = resData.data["status"];
      this.listStatus = listData;
    },

    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where ={
        active: {_eq: true}
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: {name: "asc"}
        }
      })
      var listData = resData.data["farm"];
      this.listFarm = listData;
    },

    async getListUnit() {
      var gqLQueryList = DataServices.getList("cs_unit", { "fields": "id, name" });
      var where = {
        active: { _eq: true },
        farm_id: { _eq: this.farm.id },
        deleted: { _eq: false }
      };
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" }
        }
      });
      var listData = resData.data["cs_unit"];
      this.unitOptions = listData.map(unit => {
        let [unit_name] = unit.name.split(" - ");
        return { ...unit, name: unit_name };
      });
    },

    async getListUser() {
      var gqLQueryList = DataServices.getList("users", { "fields": "id, fullname" });
      var where = {
        active: { _eq: true },
        farm_id: { _eq: this.farm.id }
      };
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { fullname: "asc" }
        }
      });
      var listData = resData.data["users"];
      this.userOptions = listData;
    },

    async getListTypeWork() {
      var gqLQueryList = DataServices.getList("type_work", { "fields": "id, name" });
      var where = {
        active: { _eq: true }
      };
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { name: "asc" }
        }
      });
      var listData = resData.data["type_work"];
      this.listTypeWork = listData;
    },

    updateSpans() {
      this.spans = [
        ...this.user.map((item) => ({ name: item.fullname, type: 'user' })),
        ...this.unit.map((item) => ({ name: item.name, type: 'unit' })),
      ];
    },

    removeSpan(index, type) {
      if (type === 'user') {
        this.user = this.user.filter((item, idx) => idx !== index);
      } else if (type === 'kindtype') {
        this.unit = this.unit.filter((item, idx) => idx !== index);
      }
      this.updateSpans();
    },

    async validateData() {
      this.validationErrors = {};

      let farm_add = document.getElementById("farm");
      if (this.$commonFuction.isEmptyObject(this.farm)) {
        farm_add.setCustomValidity("Trang trại không được để trống!");
      } else {
        farm_add.setCustomValidity("");
      }

      let user_add = document.getElementById("user");
      if (this.user.length <= 0) {
        // console.log("user_add", this.user);
        user_add.setCustomValidity("Người phân công không được để trống!");
      } else {
        user_add.setCustomValidity("");
      }

      let type_work_add = document.getElementById("type_work");
      if (this.$commonFuction.isEmptyObject(this.type_work)) {
        type_work_add.setCustomValidity("Loại công việc không được để trống!");
      } else {
        type_work_add.setCustomValidity("");
      }

      let name_add = document.getElementById("name");
      if (this.$commonFuction.isEmpty(this.name)) {
        name_add.setCustomValidity("Tên công việc không được để trống!");
      } else {
        name_add.setCustomValidity("");
      }

      let deadline_time_add = document.getElementById("deadline_time");
      if (this.$commonFuction.isEmptyObject(this.deadline_time)) {
        deadline_time_add.setCustomValidity("Ngày hoàn thành không được để trống!");
      } else {
        deadline_time_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },

    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      var params = {
        status_id: this.status.id,
        farm: this.farm,
        unit: this.unit,
        user: this.user,
        type_work: this.type_work,
        name: this.name,
        deadline_time: this.deadline_time,
        content: this.content,
      };
      // console.log("saveData", params);
      this.$emit("save", params);
      // }
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
.cs-icon-right {
  cursor: pointer;
}
</style>
